import React, { useEffect } from 'react';
import {
  useQueryParams,
} from '@marageti/z4-lib';
import { useNavigate } from 'react-router-dom';
import LoginView from './confirmation-view';

const ConfirmationContainer = () => {
  const navigate = useNavigate();
  const { email } = useQueryParams();

  useEffect(() => {
    if (!email) {
      navigate('/login' || '/');
    }
  }, [email]);

  return (
    <LoginView email={email} />
  );
};

export default ConfirmationContainer;
